import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { AnalyticsTarget } from './analyticsTarget';
import { GtmEventType } from './gtmEventTypes/gtmEventType';
import { GtmEventTypeFactory } from './gtmEventTypes/gtmEventTypeFactory';

export class GoogleTagManager implements AnalyticsTarget {
    GA_ID = 'UA-45076517-23';
    postEvent(event: AnalyticsEvent): Promise<any> {
        const eventType: GtmEventType = new GtmEventTypeFactory().getEventTypeHandler(event);
        if (eventType) {
            const gtmEvent = eventType.getBody(event);
            if (eventType.isValidEvent(gtmEvent)) {
                return Promise.resolve(window.dataLayer.push(gtmEvent));
            }
        }
        return Promise.resolve(null);
    }

    sendExperiment(experimentId: string, variantId: number): void {
        if (window.ga && window.ga.getAll) {
            // @ts-expect-error * Automated Type Error Fix
            const uaTracker = window.ga.getAll()?.find((tracker) => tracker.get('trackingId') === this.GA_ID);
            if (uaTracker) {
                const trackerName = uaTracker.get('name');
                const exp = `${experimentId}.${variantId}`;
                window.ga(`${trackerName}.set`, 'exp', exp);
                window.ga(`${trackerName}.send`, 'event', 'Experiment', 'Trigger', exp);
            }
        }
    }
}
